import { render, staticRenderFns } from "./EditIaFiles.vue?vue&type=template&id=2ece7a63&scoped=true"
import script from "./EditIaFiles.vue?vue&type=script&lang=js"
export * from "./EditIaFiles.vue?vue&type=script&lang=js"
import style0 from "./EditIaFiles.vue?vue&type=style&index=0&id=2ece7a63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ece7a63",
  null
  
)

export default component.exports